import { useState } from 'react';

function ImageToData(props) {
    const [uploadedName, setUploadedName] = useState("add image file");
    const [uploadedImage, setUploadImage] = useState("");

    function returnImgData() {
        let taggedData = `<defs>
        <pattern id="image1" patternContentUnits="objectBoundingBox" width="1" height="1">
        <use xlink:href="#protoimage1" transform="scale(0.000555556 0.000686813)"/>
        </pattern>
        <image id="protoimage1" width="1800" height="1456" xlink:href="${uploadedImage}"/>
        </defs>`
        props.setImage1(taggedData);
    }

    function handleImage(e) {
        setUploadedName(e.target.files[0].name)
        let reader = new FileReader();
        reader.onloadend = () => {
            setUploadImage(reader.result);
        };
        reader.readAsDataURL(e.target.files[0]);
    }

    return (
        <div>
            <h3 style={{ width: "100%" }}>Main Background Image (Optional)</h3>
            <label className="fileInputLabel">
                <input style={{ display: "none" }} type="file" accept="image/*" onChange={e => handleImage(e)}></input>
                Choose Image File
            </label>
            <p className="inlineHint">900 x 728 recommended for 1x skins</p>
            <p className="inlineHint">1800 x 1456 recommended for 2x skins</p>
            <p style={{background: "white", padding: "5px", margin: "0px 12px", overflowWrap: "anywhere"}}>{uploadedName}</p>
            <h3 className="fileInputLabel" onClick={() => returnImgData()}>Use Image</h3>
            <h3 className="fileInputLabel" onClick={() => props.setImage1("")}>Remove Image</h3>
        </div>
    );
}

export default ImageToData;